import UltMeta, { Meta } from "./UltMeta/index";

class BusinessCode extends UltMeta {
    REQUIREMENT_PLAT_PREFIX = new Meta("10", "平台船运需求 业务编号前缀");
    TRANSPORT_ORDER_SHIP_PREFIX = new Meta("11", "船运单 业务编号前缀");
    PURCHASE_DEMAND_PREFIX = new Meta("20", "意向 业务编号前缀");
    PROJECT_PREFIX = new Meta("21", "项目 业务编号前缀");
    PURCHASE_CONTRACT_PREFIX = new Meta("22", "采购合同 业务编号前缀");
    PURCHASE_PAYMENT_PREFIX = new Meta("23", "采购付款 业务编号前缀");
    PURCHASE_GOODS_PREFIX = new Meta("24", "采购提货 业务编号前缀");
    PURCHASE_GOODS_RECEIPT_PREFIX = new Meta("25", "采购签收 业务编号前缀");
    PURCHASE_RECONCILIATION_PREFIX = new Meta("26", "采购结算 业务编号前缀");
    PURCHASE_INVOICE_PREFIX = new Meta("27", "采购开票 业务编号前缀");
    ADVANCE_PAYMENT_PREFIX = new Meta("30", "预付款记录 业务编号前缀");
    SERVICE_COST_PREFIX = new Meta("31", "服务费账单 业务编号前缀");
    MEMBER_OPEN_PREFIX = new Meta("32", "会员开通记录 业务编号前缀");
    PROMOTION_PREFIX = new Meta("33", "推广 业务编号前缀");
    PLATFORM_ADVANCE_PAYMENT = new Meta("34", "平台预收款");
    PRODUCT_PREFIX = new Meta("40", "商品 业务编号前缀");
    INSTALL_PROMOTION = new Meta("12", "安装推广记录 业务编号前缀");
    SHIPPING_DEPOSIT = new Meta("35", "船运定金 业务编号前缀");
    SHIP_INFO_SERVICE_FEE = new Meta("36", "船务信息服务费 业务编号前缀");
    INSTALL_PROMOTION_COMMISSION = new Meta("37", "安装推广佣金 业务编号前缀");
}
export const BUSINESS_TYPE = new BusinessCode();
